/**
 * Visibilidade LOCAL (por usuário/navegador) no mapa: 5 ícones de sensor
 * (default ocultos) e o grupo Equipamentos/hubs (default visível).
 */

import {
  TIPOS_ICONE_MAPA,
  visibilidadeIconesPadrao,
} from '@/utils/sensorMapaIcons'

const chave = (localId) => `flow.mapa-sensor-icones.visiveis.${localId}`
const chaveEquipamentos = (localId) =>
  `flow.mapa-equipamentos.visiveis.${localId}`

const idsValidos = new Set(TIPOS_ICONE_MAPA.map((tipo) => tipo.id))

export function carregarIconesSensorVisiveis(localId) {
  const visiveis = visibilidadeIconesPadrao()

  try {
    const bruto = localStorage.getItem(chave(localId))
    const ligados = bruto ? JSON.parse(bruto) : []
    if (!Array.isArray(ligados)) {
      return visiveis
    }

    ligados.forEach((id) => {
      if (idsValidos.has(id)) {
        visiveis[id] = true
      }
    })
  } catch {
    // JSON corrompido / localStorage indisponível: começa com o default.
  }

  return visiveis
}

export function gravarIconesSensorVisiveis(localId, visiveis) {
  const ligados = TIPOS_ICONE_MAPA.map((tipo) => tipo.id).filter(
    (id) => visiveis[id] === true
  )

  try {
    if (ligados.length === 0) {
      localStorage.removeItem(chave(localId))
      return
    }

    localStorage.setItem(chave(localId), JSON.stringify(ligados))
  } catch {
    // localStorage cheio/indisponível: o ajuste só não sobrevive ao reload.
  }
}

// Hubs/folhas: default ligado (é o que o mapa já mostrava). Só grava o "off".
export function carregarEquipamentosVisiveis(localId) {
  try {
    return localStorage.getItem(chaveEquipamentos(localId)) !== '0'
  } catch {
    return true
  }
}

export function gravarEquipamentosVisiveis(localId, visivel) {
  try {
    if (visivel) {
      localStorage.removeItem(chaveEquipamentos(localId))
      return
    }

    localStorage.setItem(chaveEquipamentos(localId), '0')
  } catch {
    // localStorage cheio/indisponível: o ajuste só não sobrevive ao reload.
  }
}
